/* This is a forked version of the run file browser.
   TODO: probably merge them back together */

import '../css/GroupPage.less';
import '../css/ProjectPage.less';

import * as React from 'react';
import {useCallback, useMemo, useState} from 'react';
import {useLocation} from 'react-router-dom';
import * as Url from '../util/url';
import {FilesPanel, PanelFilesConfig} from './Panel2/PanelFiles';

import * as Panel2 from './Panel2/panel';
import * as Op from './Panel2/cg/ops';
import makeComp from '../util/profiler';

interface BaseFilePathArgs {
  entityName: string;
  projectName: string;
  artifactSequenceName: string;
  artifactCommitHash: string;
  compareArtifactID?: string;
  compareArtifactSequence?: string;
}

interface ArtifactFilesProps {
  entityName: string;
  projectName: string;
  artifactTypeName: string;
  artifactSequenceName: string;
  artifactCommitHash: string;
  filePath?: string;
  useSetFilePath: (base: BaseFilePathArgs) => (newPathArray: string[]) => void;
}

const ArtifactFiles = makeComp(
  (props: ArtifactFilesProps) => {
    const {
      entityName,
      projectName,
      artifactTypeName,
      artifactSequenceName,
      artifactCommitHash,
      filePath,
      useSetFilePath,
    } = props;

    const location = useLocation();
    const hash = location.hash.slice(1);
    let compareID: string | undefined;
    let compareSequenceName: string | undefined;
    if (hash.length > 0) {
      const [compareId, compareSN] = hash.split('$');
      compareID = compareId;
      compareSequenceName = compareSN;
    }

    const [context, setContext] = useState<Panel2.PanelContext>({});
    const updateContext = useCallback<Panel2.UpdateContext>(
      newContext => {
        setContext({...context, ...newContext});
      },
      [context]
    );

    const setFilePath = useSetFilePath({
      entityName,
      projectName,
      artifactSequenceName,
      artifactCommitHash,
      compareArtifactID: compareID,
      compareArtifactSequence: compareSequenceName,
    });

    const updateConfig = useCallback(
      (newConfig: PanelFilesConfig) => setFilePath(newConfig.path || []),
      [setFilePath]
    );

    const path = Url.parseRunTabPath(filePath);
    const artifacts = useMemo(() => {
      const artifactOps = [
        Op.opRootArtifact({
          entityName: Op.constString(entityName),
          projectName: Op.constString(projectName),
          artifactTypeName: Op.constString(artifactTypeName),
          artifactId: Op.constString(
            artifactSequenceName + ':' + artifactCommitHash
          ),
        }),
      ];
      if (compareID != null) {
        artifactOps.push(
          Op.opRootArtifact({
            entityName: Op.constString(entityName),
            projectName: Op.constString(projectName),
            artifactTypeName: Op.constString(artifactTypeName),
            artifactId: Op.constString(
              (compareSequenceName ?? artifactSequenceName) + ':' + compareID
            ),
          })
        );
      }
      return Op.oneOrMany(artifactOps);
    }, [
      entityName,
      projectName,
      artifactTypeName,
      artifactSequenceName,
      artifactCommitHash,
      compareSequenceName,
      compareID,
    ]);

    return (
      <FilesPanel
        config={{path}}
        configMode={false}
        loading={false}
        input={{path: artifacts as any}}
        context={context}
        updateConfig={updateConfig}
        updateContext={updateContext}
      />
    );
  },
  {id: 'ArtifactFiles'}
);

export default ArtifactFiles;
